import { useEffect, useState } from 'react';
import './league-history.styles.scss';
import { Link } from 'react-router-dom';
import { listenToDoc } from '@/utils/getDataFromDb';
import TeamBadge from '@/components/SHARED/team-badge/team-badge.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';

// The league's finished seasons, newest first, from summary/history.
// Each links to that season's page (past-season).
const LeagueHistory = ({ league }) => {

    const [ history, setHistory ] = useState(undefined);

    useEffect(() => {
        let unsub;
        listenToDoc({
            'path': `leagues/${league.id}/summary/history`,
            'callback': setHistory,
            'handleListener': (u) => { unsub = u; },
        });
        return () => { if (unsub) unsub(); }
    }, [league.id])

    if (history === undefined) return <div className='center-col'><ThreeDotsLoader /></div>;
    const seasons = Object.values(history?.seasons ?? {}).sort((a, b) => b.year - a.year);
    const college = league.type !== 'pro';

    return (
        <div className='league-history'>
            <div className='g-card'>
                <h3>League history</h3>
                {seasons.length === 0 ?
                    <p className='meta'>Seasons appear here once they&apos;re over and put in the record books, on the first day of the offseason.</p> :
                    <ul className='season-list'>
                        {seasons.map(s => (
                            <li key={s.year}>
                                <Link to={String(s.year)} className='season-row'>
                                    <span className='season-year'>Season {s.year}</span>
                                    <span className='season-champ'>
                                        {s.champion ?
                                            <>
                                                <TeamBadge team={s.champion} size='sm' />
                                                <span>
                                                    <b>{s.champion.name}</b> <span className='meta'>{s.champion.record.w}-{s.champion.record.l}</span>
                                                    <span className='meta season-more'>
                                                        {s.runnerUp && <>Runner-up: {s.runnerUp.name}</>}
                                                        {college && s.top && s.top.id !== s.champion.id && <> · Final #1: {s.top.name}</>}
                                                    </span>
                                                    {s.poy && <span className='meta season-more'>Player of the Year: {s.poy.name} ({s.poy.abbr})</span>}
                                                </span>
                                            </> :
                                            <span className='meta'>No champion</span>}
                                    </span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                }
            </div>
        </div>
    )
}

export default LeagueHistory
